import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const HeightIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 3L18 21C18 22.1 17.1 23 16 23L8 23C6.9 23 6 22.1 6 21L6 3C6 1.9 6.9 1 8 1L16 1C17.1 1 18 1.9 18 3ZM8 4L8 20C8 20.55 8.45 21 9 21H15C15.55 21 16 20.55 16 20V19H13C12.45 19 12 18.55 12 18C12 17.45 12.45 17 13 17H16V15L13 15C12.45 15 12 14.55 12 14C12 13.45 12.45 13 13 13L16 13V11L13 11C12.45 11 12 10.55 12 10C12 9.45 12.45 9 13 9H16L16 7L13 7C12.45 7 12 6.55 12 6C12 5.45 12.45 5 13 5L16 5V4C16 3.45 15.55 3 15 3L9 3C8.45 3 8 3.45 8 4Z"
        fill={color}
      />
      <mask
        id="mask0_938_11744"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="6"
        y="1"
        width="12"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 3L18 21C18 22.1 17.1 23 16 23L8 23C6.9 23 6 22.1 6 21L6 3C6 1.9 6.9 1 8 1L16 1C17.1 1 18 1.9 18 3ZM8 4L8 20C8 20.55 8.45 21 9 21H15C15.55 21 16 20.55 16 20V19H13C12.45 19 12 18.55 12 18C12 17.45 12.45 17 13 17H16V15L13 15C12.45 15 12 14.55 12 14C12 13.45 12.45 13 13 13L16 13V11L13 11C12.45 11 12 10.55 12 10C12 9.45 12.45 9 13 9H16L16 7L13 7C12.45 7 12 6.55 12 6C12 5.45 12.45 5 13 5L16 5V4C16 3.45 15.55 3 15 3L9 3C8.45 3 8 3.45 8 4Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_938_11744)"></g>
    </IconBase>
  );
};

export default HeightIcon;
